import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ReportTypeViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  descriptionValue?: { displayId: string; id: string } | null;
  description: string;
};

export const ReportTypeViewForm: React.FC<ReportTypeViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name = "",
    description = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupReportTypeLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name}
                label={langStore.ReportTypeNameLabel}
              />
              <ShowMultiLine
                value={description}
                label={langStore.ReportTypeDescriptionLabel}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
